import React from 'react';
import { Typography, Divider, Grid } from '@mui/material';
import makeStyles from './styles';

// eslint-disable-next-line react/no-unused-prop-types
type DeviceLabel = { option: JSX.Element | any, dealer:boolean };

const DeviceLabel = ({ option, dealer }: DeviceLabel) => {
  const classes = makeStyles();
  return (
    <div className={classes.scrollFix}>
      {option.group && (
        <>
          <Grid
            className={classes.listHeading}
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            container
            spacing={3}
          >
            {dealer &&
            <Grid item xs={12}>
                <Typography variant="h6">Dealer</Typography>
            </Grid>
            }
            {!dealer && <>
              <Grid item xs={4}>
                <Typography variant="h6">Make &amp; Asset SN</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h6">Device Type/Device SN</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h6">Device Id</Typography>
              </Grid></>
            }
          </Grid>
          <Divider />
        </>
      )}
      {option.children}
    </div>
  );
};

export default DeviceLabel;
